<template>
    <div class="page-content">
        <div class="business-daily">
        <h1 class="page-title">{{ $locale("sideMenu.reports.businessDaily") }}</h1>

        <!-- Search Area -->
        <el-row :gutter="10" class="search-area">
            <el-col :span="10">
              <CommDatePicker
                v-model="filter.date"
                :value.sync="filter.date"
                width="100%"
                :showWeekly="true"
                :pickerOptions="datePickerOptions"
              />
                <!-- <DatePickerGroup
                  v-bind:start="filter.startDate"
                  v-bind:end="filter.endDate"
                  @setFatherDate="getDate"
                ></DatePickerGroup> -->
            </el-col>

            <el-col :span="14" class="ta-r">
                <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.confirm2") }}</el-button>
                <el-button class="egl-btn-yellow" @click="downloadCsv">{{ $locale("global.exportToCSV") }}</el-button>
                <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
            </el-col>
        </el-row>

        <div class="checkbox-group">
            {{ $locale('business.displayExclude') }}
            <el-checkbox-group v-model="checkboxGroup">
                <el-checkbox :label="unDisplayNoBoxOffice">{{ $locale('business.freeMobilization') }}</el-checkbox>
                <el-checkbox :label="unDisplayMobilize">{{ $locale('business.coordMobilization') }}</el-checkbox>
            </el-checkbox-group>
        </div>

        <!-- print Area -->
        <div id="print">
          <div class="table-module info-supplement-container">
            <h3 class="info-title">
              <span class="titleContainer">
                <span>{{ $locale('business.businessDailyReport') }}</span>
                <span class="cinemaName">
                  <span>{{ $locale('global.cinemaName') }}：{{ cinemaName }}</span>
                  <span>{{ $locale('business.date') }}：{{ reportOfTime }}</span>
                </span>
              </span>

              <span class="exportTime">
                <span>{{ $locale('trans.report.generatedate') }}：{{ exportAtTime }}</span>
              </span>
            </h3>
          </div>

          <div class="sub_title">1. {{ $locale('business.balance')}}</div>
          <CustomTable
              :tableData="salesCashTableData"
              :accumulated="salesCashTableSum"
            >
          </CustomTable>

          <el-row class="table-group custom-border-table" type="flex">
              <el-col style="width: auto">
                <el-table
                  class="egl-table people-table"
                  style="width: 100%"
                  :data="peopleData"
                  :border="true"
                >
                  <el-table-column
                    :label="peopleDataLabel[0].label"
                    prop="number"
                    width="150"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col style="width: auto; padding: 0 30px;">
                <el-table
                  class="egl-table dayCash-table"
                  style="width: 100%"
                  :data="dayCashSalesTableData"
                  :border="true"
                >
                  <el-table-column
                    v-for="(item, idx) in dayCashSalesTableLabel"
                    :key="idx"
                    :label="item.label"
                    :prop="item.prop"
                    :width="item.width"
                    :align="item.align"
                    header-align="center"
                  >
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col style="width: auto">
                <el-table
                  class="egl-table befor-next-table"
                  style="width: 100%"
                  :data="nextBeforeTableData"
                  :border="true"
                  :span-method="objectSpanMethod"
                >
                  <el-table-column
                    v-for="(item, idx) in nextBeforeTableLabel"
                    :key="idx"
                    :label="item.label"
                    :prop="item.prop"
                    :width="item.width"
                    :align="item.align"
                    header-align="center"
                  >
                  </el-table-column>
                </el-table>
              </el-col>
          </el-row>

          <div class="sub_title">2. {{ $locale('business.refund')}}</div>

          <!-- <div class="sub_title">3. {{ $locale('business.accounting')}}</div> -->
          <CustomTable
            :isNegative="true"
            :tableData="salesCashBalanceRefundUpdateData"
            :accumulated="salesCashBalanceRefundUpdateSum"
          >
          </CustomTable>
        </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/Report/CustomTable";
import CommDatePicker from "@/components/common/CommDatePicker";
import "@/assets/style/businessDaily.less";
import { getDailySalesReport } from "@/helpers/service/api/report";
import { toThousands } from "@/utils/common";
import moment from "moment";
import json2csv from "json2csv";
import { getExportName_fn } from '@/utils/common'

export default {
  name: "BusinessDaily",
  data() {
    return {
      cinemaName: "",
      tableLabel: [
        {
          width: 150,
          label: "売上精算",
          prop: "field"
        },
        {
          width: 130,
          label: "チケット",
          prop: "ticket",
        },
        {
          width: 130,
          label: "コンセ",
          prop: "concession",
        },
        {
          width: 130,
          label: "物販",
          prop: "commercial",
        },
        {
          width: 130,
          label: "その他営収",
          prop: "otherRevenue",
        },
        {
          width: 130,
          label: "売上合計",
          prop: "salesTotal",
        },
        {
          width: 130,
          label: "先売券販売",
          prop: "preSalesTicket",
        },
        {
          width: 130,
          label: "劇場前売券販売",
          prop: "advanceTicketSales",
        },
        {
          width: 130,
          label: "全国共通券販売",
          prop: "nationalTicketSales",
        },
        {
          width: 130,
          label: "収入合計",
          prop: "totalAmount",
        },
        {
          width: 130,
          label: "過不足",
          prop: "totalInsufficient",
        },
        {
          width: 130,
          label: "実収入合計",
          prop: "actualTotal",
        },
      ],
      unDisplayMobilize: "unDisplayMobilize",
      unDisplayNoBoxOffice: "unDisplayNoBoxOffice",
      filter: {
        startDate: 0,
        endDate: 0,
        date: this.$moment().startOf("day").valueOf(),
      },
      cinemaId: window.localStorage.getItem("cinemaId"),
      checkboxGroup: [],
      salesCashTableData: [],
      salesCashTableSum: {},
      salesCashBalanceRefundUpdateData: [],
      salesCashBalanceRefundUpdateSum: {},
      dayCashSalesTableLabel: [
        {
          width: 140,
          label: "当日現金収支",
          prop: "label",
          align: "center"
        },
        {
          width: 130,
          label: "金額",
          prop: "amount",
          align: "right"
        }
      ],
      nextBeforeTableLabel: [
        {
          width: 150,
          label: "前日繰越/現金収支",
          prop: "dayBeforeLabel",
          align: "left"
        },
        {
          width: 130,
          label: "金額",
          prop: "dayBeforePrice",
          align: "right"
        },
        {
          width: 130,
          label: "合計",
          prop: "dayBeforeSum",
          align: "right"
        },
        {
          width: 150,
          label: "現金精算/翌日繰越",
          prop: "nextDayLabel",
          align: "left"
        },
        {
          width: 130,
          label: "金額",
          prop: "nextDayPrice",
          align: "right"
        },
        {
          width: 130,
          label: "合計",
          prop: "nextDaySum",
          align: "right"
        },
      ],
      resData: {},
      nextBeforeTableData: [],
      dayCashSalesTableData: [],
      peopleData: [],
      peopleDataLabel: [
        {
          label: "動員",
        }
      ],
      exportAtTime: "",
      reportOfTime: "",
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      printObj: {
        popTitle: this.$locale("sideMenu.reports.businessDaily"),
        id: "print",
      }
    };
  },
  methods: {
    getDate(num) {
      this.filter = {
        ...this.filter,
        date: num
      };
    },
    search_fn() {
      const requestParam = {
        cinemaId: this.cinemaId,
        date:  this.filter.date === 0 ? moment().format("YYYY-MM-DD") :  moment(this.filter.date).format("YYYY-MM-DD"),
        unDisplayMobilize: this.checkboxGroup.includes(this.unDisplayMobilize),
        unDisplayNoBoxOffice: this.checkboxGroup.includes(this.unDisplayNoBoxOffice),
      };

      getDailySalesReport(requestParam).then(res =>{
        if(res.success) {
          if (res.data === null) {
            this.salesCashTableSum = {};
            this.salesCashTableData = [];
            this.salesCashBalanceRefundUpdateSum = {};
            this.salesCashBalanceRefundUpdateData = [];
            this.nextBeforeTableData = [];
            this.dayCashSalesTableData = [];
            this.peopleData = [];

            this.exportAtTime = "";
            this.reportOfTime = "";
            this.cinemaName = "";
          } else {
            this.salesCashTableSum = res.data.salesCashBalance.salesSettlement.accumulated;
            this.salesCashTableData = this.formatSalesCashData(res.data.salesCashBalance.salesSettlement);
            this.salesCashBalanceRefundUpdateSum = res.data.salesCashBalanceRefundUpdate.accumulated;
            this.salesCashBalanceRefundUpdateData = this.formatSalesCashData(res.data.salesCashBalanceRefundUpdate);
            this.nextBeforeTableData = this.formatNextBeforeData(res.data.salesCashBalance);
            this.dayCashSalesTableData = this.formatDayCashSalesData(res.data.salesCashBalance);
            this.peopleData.splice(0,1,{ number: this.formatNum(res.data.salesCashBalance.mobilizeNumber) + "人" });

            moment.locale("ja");
            this.exportAtTime = moment.unix(res.data.exportAt / 1000).format("YYYY-MM-DD (ddd)  hh:mm:ss");
            this.reportOfTime = moment.unix(res.data.reportOf / 1000).format("YYYY-MM-DD (ddd)");
            this.cinemaName = res.data.cinema;
          }
        }
      });
    },
    formatSalesCashData(data) {
      let arr = [];

      arr.push(data.salesInCash);
      Object.keys(data.salesInAccountsReceivable).forEach(name => {
        arr.push(Object.assign({ type: "salesInAccountsReceivable" }, data.salesInAccountsReceivable[name]));
      });

      Object.keys(data.salesPrePayment).forEach(name => {
        arr.push(Object.assign({ type: "salesPrePayment" }, data.salesPrePayment[name]));
      });
      return arr;
    },
    formatNextBeforeData(data) {
      let arr = [];
      const beforelabelArr = [
        this.$locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.openAmount"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.treasuryRemnant"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashPrevious"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.dayBefore"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashBalance"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.supplementaryEtc"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashBudget"),
        this.$locale("global.total"),
      ];
      const beforelabelKeys = ["realChangeReserve", "dayBeforeSafeRemain", "dayBeforeUndeposited", "dayBeforeTotal", "cashBalance", "cashBalanceRefundUpdate",
      "cashBalanceTotal", "allTotal"]
      const nextlabelKeys = ["smallCashTransfer", "depositAmount", "cashSettlementTotal", "changeCarryforwardReserve", "carryoverSafeBalance", "undepositedCash",
      "nextDayTotal", "allTotal"]
      const nextlabelArr = [
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.smallCashTransfer"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.depositAmount"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashAdjustmentMeter"),
        this.$locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.changeReserve"),
        // this.$locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.rowLabel.changeReserve"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.remainsOfBank"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.cashCarried"),
        this.$locale("dailyClosing.cashTableDialog.cashSettlementTable.rowLabel.nextDay"),
        this.$locale("global.total"),
      ];
      let keys = Object.keys(data.dayBeforeCashBalance)
      keys.splice(keys.indexOf("changeReserve"), 1)
      // const beforelabelArr = ["釣銭準備金", "前日金庫残", "前日未預入現金", "前日繰越 計", "現金収支", "レジ締め済等取引 の追加/払戻/修正", "現金収支 計", "合計"];
      // const nextlabelArr = ["小口現金振替", "預金金額", "現金精算 計", "繰越釣銭準備金", "繰越金庫残", "繰越未預入現金", "翌日繰越 計", "合計"];
      for (let i = 0; i < keys.length; i++) {
        console.log(beforelabelKeys[i])
        arr.push({
          dayBeforeLabel: beforelabelArr[i],
          dayBeforePrice: beforelabelKeys[i].indexOf("Total") > -1 ? "" : this.formatPrice(data.dayBeforeCashBalance[beforelabelKeys[i]]),
          dayBeforeSum: beforelabelKeys[i].indexOf("Total") > -1 ? this.formatPrice(data.dayBeforeCashBalance[beforelabelKeys[i]]) : ""
        })
      }
      // Object.keys(data.dayBeforeCashBalance).forEach((name, index)=>{
      //   let itemfield = {};
      //   if (name.indexOf("Total") > -1) {
      //     itemfield = { dayBeforePrice: "", dayBeforeSum: this.formatPrice(data.dayBeforeCashBalance[name]) };
      //   } else {
      //     itemfield = { dayBeforeSum: "", dayBeforePrice: this.formatPrice(data.dayBeforeCashBalance[name]) };
      //   }
      //   const arrItem = {
      //     dayBeforeLabel: beforelabelArr[index],
      //     ...itemfield
      //   };
      //   arr.push(arrItem);
      // });
      // Object.keys(data.nextDayCashSettlement).forEach((name, index)=>{
      //   let itemfield = {};

      //   if (name.indexOf("Total") > -1) {
      //     itemfield = { nextDayPrice: "", nextDaySum: this.formatPrice(data.nextDayCashSettlement[name]) };
      //   }else {
      //     itemfield = { nextDaySum: "", nextDayPrice: this.formatPrice(data.nextDayCashSettlement[name]) };
      //   }

      //   const arrItem = {
      //     nextDayLabel: nextlabelArr[index],
      //     ...itemfield
      //   };

      //   arr[index] = Object.assign(arr[index], arrItem);
      // });
      for (let i = 0; i < Object.keys(data.nextDayCashSettlement).length; i++) {
        let item = {
          nextDayLabel: nextlabelArr[i],
          nextDayPrice: nextlabelKeys[i].indexOf("Total") > -1 ? "" : this.formatPrice(data.nextDayCashSettlement[nextlabelKeys[i]]),
          nextDaySum: nextlabelKeys[i].indexOf("Total") > -1 ? this.formatPrice(data.nextDayCashSettlement[nextlabelKeys[i]]) : ""
        }
        arr[i] = Object.assign(arr[i], item)
      }
      console.log(arr)
      return arr;
    },
    formatDayCashSalesData(data) {
      let arr = [];

      const labelArr = ["現金収入", "売掛金現金回収", "買掛金現金支払", "その他仕入現金支払", "合計"];

      Object.keys(data.dayCashSales).forEach((name, index)=>{
        const arrItem = {
          label: labelArr[index],
          amount: this.formatPrice(data.dayCashSales[name])
        };
        arr.push(arrItem);
      });

      return arr;
    },
    formatPrice(value) {
      return this.formatNum(value) + this.$locale("global.circle");
    },
    formatNum(value) {
      return toThousands(value);
    },
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        if (row.dayBeforeLabel && row.dayBeforeLabel.indexOf("計") > -1) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
      }
      if (columnIndex === 1) {
        if (!row.dayBeforePrice) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 3) {
        if (row.nextDayLabel && row.nextDayLabel.indexOf("計") > -1) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
      }
      if (columnIndex === 4) {
        if (!row.nextDayPrice) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    csvExportDataMassage() {
      let newLine = {
        actualTotal: "",
        advanceTicketSales: "",
        commercial: "",
        concession: "",
        field: "",
        nationalTicketSales: "",
        otherRevenue: "",
        preSalesTicket: "",
        salesTotal: "",
        ticket: "",
        totalAmount: ""
      };

      let customTableHead = this.tableLabel.map(name => {
        return {
          [name.prop]: name.label
        };
      }).reduce((currentObj, _keyObj) => {
        return { ...currentObj, ..._keyObj };
      }, {});


      let table1Data = [customTableHead, ...this.salesCashTableData, this.salesCashTableSum];
      let table2Data = [customTableHead, ...this.salesCashBalanceRefundUpdateData, this.salesCashBalanceRefundUpdateSum];

      table1Data = this.convertCustomTableCol1(table1Data);
      table2Data = this.convertCustomTableCol1(table2Data);

      let tableHeader = {};
      let tableBody = {};
      let tableArr = [];
      let bodyStart = 0;
      let allLabel = [...this.peopleDataLabel, ...this.dayCashSalesTableLabel, ...this.nextBeforeTableLabel];

      this.nextBeforeTableData.forEach((_data, i) => {
        let indexStart = 0;
        tableBody = {};
        bodyStart = 0;

        if (i === 0) {
          allLabel.forEach((_pData, _aIndex) => {
            tableHeader[this.tableLabel[indexStart].prop] = _pData.label;

            if (_aIndex === Object.keys(this.peopleData[0]).length - 1 || (_aIndex === (Object.keys(this.dayCashSalesTableData[0]).length - 1 + Object.keys(this.peopleData[0]).length - 1 + 1))) {
              indexStart += 2;
            } else {
              indexStart ++;
            }
          });
          tableArr.push(tableHeader);
        }

        tableBody[this.tableLabel[bodyStart].prop] = this.peopleData[i] ? this.peopleData[i].number : "";
        bodyStart += 2;

        if (this.dayCashSalesTableData.length > 0) {
          Object.keys(this.dayCashSalesTableData[0]).forEach(key => {
            tableBody[this.tableLabel[bodyStart].prop] = this.dayCashSalesTableData[i] && this.dayCashSalesTableData[i][key] ? this.dayCashSalesTableData[i][key] : "";
            bodyStart++;
          });
        }
        bodyStart ++;

        if (this.nextBeforeTableData.length > 0) {
          // render col following this order
          let order = ["dayBeforeLabel", "dayBeforePrice", "dayBeforeSum","nextDayLabel","nextDayPrice","nextDaySum"];
          order.forEach(key => {
            tableBody[this.tableLabel[bodyStart].prop] = this.nextBeforeTableData[i] && this.nextBeforeTableData[i][key] ? this.nextBeforeTableData[i][key] : "";
            bodyStart++;
          });
        }
        Object.keys(tableBody).forEach(key => {
          tableBody[key] = tableBody[key].replace("円", "")
        })
        tableArr.push(tableBody);
      });

      return [...table1Data, newLine, ...tableArr, newLine, ...table2Data];
    },
    convertCustomTableCol1(tableData) {
      let data = JSON.parse(JSON.stringify(tableData));

      let col1Name = ["売上精算","現金売上","売掛金売上","窓口決済","オンライン 決済","全国共通券 着券","劇場引換券 着券","その他営収","前受金売上","先売券着券","劇場前売券 着券","合計"];

      data.forEach(_data => {
        for(let key in _data) {
          _data[key] = _data[key] === null ? "-" : typeof _data[key] === "number" ? this.formatNum(_data[key]) : _data[key];
        }
      });

      return data.map((_cash, i) => {
        // remove type
        if (_cash.hasOwnProperty("type")) {
          delete _cash.type;
        }
        return {
          ..._cash,
          field: col1Name[i]
        };
      });
    },
    downloadCsv() {
      let theData = this.csvExportDataMassage();

      try {
        const result = json2csv.parse(theData, {
          // fields: this.getColumnLabelList(), //we do not use fields to generate table head
          header: false
        });
        // determine browser type
        if ((navigator.userAgent.indexOf("compatible") > -1 &&
            navigator.userAgent.indexOf("MSIE") > -1) ||
            navigator.userAgent.indexOf("Edge") > -1) {
          //IE10 or Edge
          let BOM = "\uFEFF";
          let csvData = new Blob([ BOM + result ], { type: "text/csv" });
          navigator.msSaveBlob(csvData, "businessDaily.csv");
        } else {
          //non-IE
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
          //use a tag to implement download
          let link = document.createElement("a");
          link.href = encodeURI(csvContent);
          // link.download = `
          // ${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("sideMenu.reports.businessDaily")}.csv
          // `;
          link.download = getExportName_fn(
            this.$locale('sideMenu.reports.businessDaily'),
            '',
            '',
            '',
            this.$moment(this.filter.date).format('YYYY-MM-DD'),
            this.cinemaName,
            this.$moment().format('YYYYMMDDHHmm')
          ) + 'csv'
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (err) {
        alert(err);
      }
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
  },
  mounted() {
    this.search_fn();
  },
  components: {
    CommDatePicker,
    CustomTable
  }
};
</script>

<style lang="less">
.table-group {
  margin-bottom: 32px;
  overflow-x: scroll;
  .befor-next-table .el-table__body-wrapper tbody {
    .el-table__row{
      td {
        padding-left: 12px;
        &[colspan="2"]{
          background-color: @secondly-orange;
          text-align: left;
          padding-left: 56px;
          + td{
            background-color: @secondly-orange;
          }
        }
      }
      &:last-child{
        td{
          &[colspan="2"]{
            text-align: right;
            padding-right: 56px;
            + td{
              background-color: @secondly-yellow;
            }
          }
        }
      }
    }
  }
  .egl-table{
    height: fit-content;
    width: fit-content;
    .el-table__body-wrapper tbody {
      .el-table__row{
        &:not(:only-child){
          &:last-child{
            td{
              background-color: @secondly-yellow;
              color: @primary-black;
            }
          }
        }
      }
    }
  }

}

.info-supplement-container {
  .info-title {
    display: flex;
    justify-content: space-between;

    .titleContainer {
      display: flex;

      .cinemaName {
        margin-left: 50px;
        display: flex;
        flex-direction: column;
      }
    }

    .exportTime {
      display: flex;
      align-items: center;
    }
  }
}

.sub_title{
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 26px;
}

</style>
